
import React from 'react';

const NextStepsSection = () => {
  return (
    <div className="bg-gray-50 rounded-lg p-6 mb-8">
      <h3 className="text-lg font-medium mb-4">Mida järgmiseks?</h3>
      <ul className="space-y-3">
        <li className="flex">
          <span className="bg-kaija-accent text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0">1</span>
          <p>Naudi kursust - kõik materjalid on nüüd sulle kättesaadavad ja saad alustada omas tempos.</p>
        </li>
        <li className="flex">
          <span className="bg-kaija-accent text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0">2</span>
          <p>Kui sul on kursuse kohta küsimusi, siis kirjuta mulle aadressil kaija@kaijaalliksaar.ee</p>
        </li>
        <li className="flex">
          <span className="bg-kaija-accent text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0">3</span>
          <p>Kui sul on küsimusi oma varasema makse või ostu kohta, siis palun võta minuga ühendust e-maili aadressil kaija@kaijaalliksaar.ee</p>
        </li>
      </ul>
    </div>
  );
};

export default NextStepsSection;
